import script from "./DetalleTorneoGestionView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetalleTorneoGestionView.vue?vue&type=script&setup=true&lang=ts"

import "./DetalleTorneoGestionView.vue?vue&type=style&index=0&id=5c5b7ad0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c5b7ad0"]])

export default __exports__